export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-f3bb4fd5',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
